import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Checkbox } from "@mui/material";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import React from "react";

interface AutocompleteHighlightProps {
  renderProps: React.HTMLAttributes<HTMLLIElement>;
  optionLabel: string;
  inputValue: string;
  multiSelect?: boolean;
  selected?: boolean;
}

interface Part {
  text: string;
  highlight: boolean;
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export function AutocompleteHighlight(props: AutocompleteHighlightProps) {
  const { renderProps, selected, inputValue, optionLabel, multiSelect } = props;
  const matches = match(optionLabel, inputValue, { insideWords: true });
  const parts = parse(optionLabel, matches);

  return (
    <li {...renderProps}>
      {multiSelect && <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} style={{ marginRight: 8 }} />}
      <div>
        {parts.map((part: Part, index: number) => (
          <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
            {part.text}
          </span>
        ))}
      </div>
    </li>
  );
}
